module.exports = __webpack_public_path__ + "static/media/Inter_18pt-Regular.37dcabff.ttf";